import React, { useEffect, useState } from 'react';
import ServiceBanner from '../../components/ServiceBanner';
import ServicePremimum from '../../components/ServicePremimum';
import ServicePlan from '../../components/ServicePlan';
import { getSeoByUrl } from '../../api/api';

const Service = () => {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("service"); 
        
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
          console.log("Service page SEO loaded:", response.data.metaTitle);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, []);

  const updateMetaTags = (data) => {
    if (data.metaTitle) document.title = data.metaTitle;
        let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
        let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
        let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (data.canonicalUrl) canonicalLink.setAttribute('href', data.canonicalUrl);
    
    if (data.schemaMarkup) {
      let existingScript = document.querySelector('#schema-markup');
      if (existingScript) existingScript.remove();
      
      const script = document.createElement('script');
      script.id = 'schema-markup';
      script.type = 'application/ld+json';
      script.textContent = data.schemaMarkup;
      document.head.appendChild(script);
    }
  };

  return (
    <div>
      <ServiceBanner />
      <ServicePremimum />
      <ServicePlan />
    </div>
  );
};

export default Service;